import i18n from 'app/utils/translation/i18n';

interface Aliases {
  value: string;
  label: string;
  maxLength?: number;
}

let aniPayTypes: Aliases[];

i18n.on('loaded', () => {
  aniPayTypes = [
    { value: 'PIN', label: i18n.t('anipay.pin'), maxLength: 7 },
    { value: 'EMAIL', label: i18n.t('anipay.email'), maxLength: 50 },
    { value: 'MOBILE', label: i18n.t('anipay.mobileNumber') },
    { value: 'TIN', label: i18n.t('anipay.tin'), maxLength: 10 },
  ];
});

export { aniPayTypes };
